var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 31,
    viewBox: "0 0 38 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3232 22.0794L37.6566 15.4128L29.3232 8.74609V13.7461H14.3232V17.0794H29.3232V22.0794Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3445 0.41119C17.3153 0.405726 19.2676 0.791374 21.0883 1.5458C22.9089 2.30022 24.5618 3.40842 25.9512 4.80619L23.5945 7.16286C21.3912 4.95952 18.4612 3.74452 15.3445 3.74452C12.2278 3.74452 9.29784 4.95952 7.09451 7.16286C4.89117 9.36619 3.67617 12.2962 3.67617 15.4129C3.67617 18.5295 4.89117 21.4595 7.09451 23.6629C9.29784 25.8662 12.2278 27.0812 15.3445 27.0812C18.4612 27.0812 21.3912 25.8662 23.5945 23.6629L25.9512 26.0195C23.1195 28.8529 19.3528 30.4145 15.3445 30.4145C11.3362 30.4145 7.5695 28.8529 4.73784 26.0195C1.9045 23.1879 0.34284 19.4212 0.34284 15.4129C0.34284 11.4045 1.9045 7.63786 4.73784 4.80619C6.12718 3.40842 7.78007 2.30022 9.60075 1.5458C11.4214 0.791374 13.3737 0.405726 15.3445 0.41119Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutIcon);
export default __webpack_public_path__ + "static/media/check_out_icon.919a17dbccb91f476c68d0f9dc4ce444.svg";
export { ForwardRef as ReactComponent };